import { $, $$ } from 'utils/dom';
import MobileAccordion from 'modules/mobile-accordion';

const relatedLinksAccordions = $$('.related-links__accordion');
relatedLinksAccordions.length &&
  relatedLinksAccordions.forEach(accordion => {
    new MobileAccordion({
      container: accordion,
      handler: $('button', accordion),
      target: $('ul', accordion),
      breakpoint: 1200,
    }).init();
  });
